// this is an autogenerated file from DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_ManualAutomations_Content_Content_ActiveAction_CreateProcedureReceivables($id: uuid!) {
  vaxiom_patients(where: { _id: { _eq: $id } }) {
    id
    human_readable_id
    primary_location {
      id
      name
    }
    person {
      id
      profile_pic_url
      gender
      birth_date
      greeting
      first_name
      last_name
    }
    insurance_payment_accounts: payment_accounts(
      where: { insured_id: { _is_null: false } }
    ) {
      insured_id
      insurance_company_id
    }
  }
}

`